// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__1gVXa","checkbox":"Checkbox_checkbox__3gL0B","icon":"Checkbox_icon__2rXNw"};